import { Chip } from '@patchbay/ui'

export const PUBLIC_NOTE_LABEL = 'Public note · customer-visible'

export function PublicNoteBadge() {
  return <Chip tone="primary">{PUBLIC_NOTE_LABEL}</Chip>
}
